// src/data/nom035Ranges.js

const nom035Ranges = {
  global: {
    // Umbrales globales
    range: [
      "0-50",    // Nulo
      "50-75",   // Bajo
      "75-99",   // Medio
      "99-140",  // Alto
      "140+"     // Muy alto
    ]
  },

  categoryDomains: {
    // Ambiente de trabajo (Environment)
    environment: {
      // Rango de la categoría
      range: ["0-5", "5-9", "9-11", "11-14", "14+"],
      // Dominios que componen esta categoría
      domains: {
        conditions: {
          // Condiciones ambientales (Bloque 1)
          range: ["0-5", "5-9", "9-11", "11-14", "14+"]
        }
      }
    },

    // Factores de la actividad (Factors)
    factors: {
      range: ["0-15", "15-30", "30-45", "45-60", "60+"],
      domains: {
        workload: {
          // Cantidad y ritmo de trabajo (Bloques 2–4 y 13)
          range: ["0-15", "15-21", "21-27", "27-37", "37+"]
        },
         control: {
      // Control (Bloques 6–8, ítems 23–30,35–36)
          range: ["0-11", "11-16", "16-21", "21-25", "25+"]
        },
      }
    },

    // Organización del tiempo (Time Organization)
    timeOrganization: {
      range: ["0-5", "5-7", "7-10", "10-13", "13+"],
      domains: {
        workday: {
          // Jornada y conciliación (Bloque 5, ítems 17–18)
          range: ["0-1", "1-2", "2-4", "4-6", "6+"]
        },
        interference: {
          // Interferencia en la vida personal (Bloque 5, ítems 19–22)
          range: ["0-4", "4-6", "6-8", "8-10", "10+"]
        }
      }
    },

    // Liderazgo y relaciones (Leadership & Relations)
    leadershipRelations: {
      range: ["0-14", "14-29", "29-42", "42-58", "58+"],
      domains: {
        leadership: {
          // Liderazgo (Bloque 8, ítems 31–34; Bloque 9)
          range: ["0-9", "9-12", "12-16", "16-20", "20+"]
        },
        relationships: {
          // Relaciones y supervisión (Bloque 10; Bloque 14)
          range: ["0-10", "10-13", "13-17", "17-21", "21+"]
        },
        violence: {
          // Violencia laboral (Bloque 12, ítems 57–64)
          range: ["0-7", "7-10", "10-13", "13-16", "16+"]
        }
      }
    },

    // Entorno organizacional (Organizational Environment)
    organizationalEnvironment: {
      range: ["0-10", "10-14", "14-18", "18-23", "23+"],
      domains: {
        recognition: {
          // Reconocimiento (Bloque 11, ítems 47–52)
          range: ["0-6", "6-10", "10-14", "14-18", "18+"]
        },
        belonging: {
          // Sentido de pertenencia (Bloque 11, ítems 53–56)
          range: ["0-4", "4-6", "6-8", "8-10", "10+"]
        }
      }
    }
  }
};
export default nom035Ranges;
